import { axiosDS } from '@pp/axios'
import { urls } from 'Src/constants/Urls'
import { Logs } from 'Pages/advertisement/models'

export const logApi = {
	getLogs: async (id: number, tab: string) => {
		const res = await axiosDS().get<Logs>(
			urls.advertisement.logs.replace(':id', `${id}`).replace(':tab', tab)
		)
		return res.data
	},
	getLogsAdriver: async (id: number, tab: string) => {
		const res = await axiosDS().get<Logs>(
			urls.advertisement.logs_adriver.replace(':id', `${id}`).replace(':tab', tab)
		)
		return res.data
	},
}
